export const feRoutes = {
	landing: "/",
	login: "/auth/login",
	methodologies: {
		newMethodologyV1: "/methodologies/new-methodology", // not used anymore
		newMethodologyV2: "/methodologies/my-methodologies/v2/new-methodology",
	},
	projects: {},
	registry: {
		index: "/registry",
		issuanceDetails: (id: string | number) => `/registry/issuance-details/${id}`,
		retirementDetails: (id: string | number) => `/registry/retirement-details/${id}`,
		transferDetails: (id: string | number) => `/registry/transfer-details/${id}`,
	},
};
